export default {
	data() {
		return {
			rangeSelection: {
				start: null,
				end: null,
				visible: false
			}
		};
	},
	computed: {
		rangeSelectionArea() {
			return [this.rangeSelection.start, this.rangeSelection.end].sort((a,b) => a-b);
		},
	},
	mounted() {
		this.$eventsBus.$on('tracker-range-selection-change', this.onTrackerRangeSelectionChange);
	},
	destroyed() {
		this.$eventsBus.$off('tracker-range-selection-change', this.onTrackerRangeSelectionChange);
	},
	methods: {
		onTrackerRangeSelectionChange(opts) {
			if (opts?.type === 'delta') {
				this.rangeSelection[opts?.position] += opts?.value;
			}

			if (opts?.type === 'value') {
				this.rangeSelection[opts?.position] = opts?.value;
			}
		},
		toggleRangeSelector() {
			this.rangeSelection.visible = !this.rangeSelection.visible;
		},
		onTrackerRulerRangeSelectionClick(e) {
			this.$eventsBus.$emit('tracker-ruler-range-selection-click', e);
		}
	}
};
